// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.upper-case {
  text-transform: uppercase;
}

.report-wrapper {
  padding: 3rem 4rem 4rem;
}

.line-divider {
  background-color: #e4e7f0;
  height: 1px;
  margin: 2rem 0 0.5rem;
}

.finding {
  background: #e7f8f5;
  padding: 1rem;
}

.report-info p {
  margin: 2px 0;
}

.source-links {
  padding: 0;
}

.source-links li {
  list-style: none;
  margin: 0.75rem 0;
}

.report-wrapper p {
  font-size: 14px;
}

.report-wrapper li {
  font-size: 14px;
}

.hover-color-green:hover {
  color: #11bc97;
}

.report-wrapper p.badge {
  margin: 0;
  vertical-align: bottom;
  font-weight: 500 !important;
  height: 20px !important;
  padding: 0 !important;
  line-height: 1.7;
}

.report-info p.badge {
  margin-left: 10px;
}

.badge.partial {
  border: 1px solid #f4b717;
  background: rgba(251, 188, 6, 0.15);
  color: #636a7d;
}

.report-wrapper .table thead th {
  border-bottom: 1px solid #dee2e6;
  border-top: 0;
}

.badge.exact {
  border: 1px solid #E66A8B;
  background: rgba(230, 106, 139, 0.2);
  color: #e66a8b;
}

.badge.different {
  border: 1px solid gray;
  color: gray;
}

.report-wrapper .table td:nth-child(1) {
  width: 13%;
  min-width: 13%;
}

.report-wrapper .table td:nth-child(2) {
  width: 16%;
  min-width: 16%;
}

.report-wrapper .table td:nth-child(3) {
  width: 16%;
  min-width: 16%;
}

.report-wrapper .table td:nth-child(4) {
  width: 30%;
  min-width: 30%;
}

.report-wrapper .table td:nth-child(5) {
  width: 20%;
  min-width: 20%;
}

.report-wrapper .table td {
  border-top: 0;
  font-size: 14px;
}

.report-wrapper .table td,
.report-wrapper .table th {
  padding: 0.35rem 0.75rem;
}

.finding .table td:nth-child(1) {
  width: 12%;
  min-width: 12%;
}

.finding .table td:nth-child(2) {
  width: 35%;
  min-width: 35%;
}

.finding .table td:nth-child(3) {
  width: 60%;
  min-width: 60%;
}

.report-wrapper td ul {
  padding: 0;
}

.report-wrapper td ul li {
  list-style: none;
  padding: 0.35rem 0;
}

.finding .table thead th {
  border: 0;
}

@media print {
  .report-wrapper .table td,
  .report-wrapper .table th {
    background-color: transparent !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/fullReport.scss"],"names":[],"mappings":"AAEA;EACE,yBAAA;AADF;;AAIA;EACE,uBAAA;AADF;;AAGA;EACE,yBAAA;EACA,WAAA;EACA,qBAAA;AAAF;;AAEA;EACE,mBAAA;EACA,aAAA;AACF;;AACA;EACE,aAAA;AAEF;;AAAA;EACE,UAAA;AAGF;;AADA;EACE,gBAAA;EACA,iBAAA;AAIF;;AAFA;EACE,eAAA;AAKF;;AAHA;EACE,eAAA;AAMF;;AAJA;EACE,cAAA;AAOF;;AALA;EACE,SAAA;EACA,sBAAA;EACA,2BAAA;EACA,uBAAA;EACA,qBAAA;EACA,gBAAA;AAQF;;AANA;EAEE,iBAAA;AAQF;;AALA;EACE,yBAAA;EACA,mCAAA;EACA,cAAA;AAQF;;AALA;EACE,gCAAA;EACA,aAAA;AAQF;;AANA;EACE,yBAAA;EACA,oCAAA;EACA,cAAA;AASF;;AAPA;EACE,sBAAA;EACA,WAAA;AAUF;;AARA;EACE,UAAA;EACA,cAAA;AAWF;;AATA;EACE,UAAA;EACA,cAAA;AAYF;;AAVA;EACE,UAAA;EACA,cAAA;AAaF;;AAXA;EACE,UAAA;EACA,cAAA;AAcF;;AAZA;EACE,UAAA;EACA,cAAA;AAeF;;AAbA;EACE,aAAA;EACA,eAAA;AAgBF;;AAdA;;EAEE,wBAAA;AAiBF;;AAfA;EACE,UAAA;EACA,cAAA;AAkBF;;AAhBA;EACE,UAAA;EACA,cAAA;AAmBF;;AAjBA;EACE,UAAA;EACA,cAAA;AAoBF;;AAlBA;EACE,UAAA;AAqBF;;AAnBA;EACE,gBAAA;EACA,kBAAA;AAsBF;;AApBA;EACE,SAAA;AAuBF;;AArBA;EACE;;IAEE,wCAAA;EAwBF;AACF","sourcesContent":["@import './colors';\n\n.upper-case {\n  text-transform: uppercase;\n}\n\n.report-wrapper {\n  padding: 3rem 4rem 4rem;\n}\n.line-divider {\n  background-color: #e4e7f0;\n  height: 1px;\n  margin: 2rem 0 0.5rem;\n}\n.finding {\n  background: #e7f8f5;\n  padding: 1rem;\n}\n.report-info p {\n  margin: 2px 0;\n}\n.source-links {\n  padding: 0;\n}\n.source-links li {\n  list-style: none;\n  margin: 0.75rem 0;\n}\n.report-wrapper p {\n  font-size: 14px;\n}\n.report-wrapper li {\n  font-size: 14px;\n}\n.hover-color-green:hover {\n  color: #11bc97;\n}\n.report-wrapper p.badge {\n  margin: 0;\n  vertical-align: bottom;\n  font-weight: 500 !important;\n  height: 20px !important;\n  padding: 0 !important;\n  line-height: 1.7;\n}\n.report-info p.badge {\n  // border: 1px solid #E66A8B;\n  margin-left: 10px;\n}\n\n.badge.partial {\n  border: 1px solid #f4b717;\n  background: rgba(251, 188, 6, 0.15);\n  color: #636a7d;\n}\n\n.report-wrapper .table thead th {\n  border-bottom: 1px solid #dee2e6;\n  border-top: 0;\n}\n.badge.exact {\n  border: 1px solid $color-pink;\n  background: rgba(230, 106, 139, 0.2);\n  color: #e66a8b;\n}\n.badge.different {\n  border: 1px solid gray;\n  color: gray;\n}\n.report-wrapper .table td:nth-child(1) {\n  width: 13%;\n  min-width: 13%;\n}\n.report-wrapper .table td:nth-child(2) {\n  width: 16%;\n  min-width: 16%;\n}\n.report-wrapper .table td:nth-child(3) {\n  width: 16%;\n  min-width: 16%;\n}\n.report-wrapper .table td:nth-child(4) {\n  width: 30%;\n  min-width: 30%;\n}\n.report-wrapper .table td:nth-child(5) {\n  width: 20%;\n  min-width: 20%;\n}\n.report-wrapper .table td {\n  border-top: 0;\n  font-size: 14px;\n}\n.report-wrapper .table td,\n.report-wrapper .table th {\n  padding: 0.35rem 0.75rem;\n}\n.finding .table td:nth-child(1) {\n  width: 12%;\n  min-width: 12%;\n}\n.finding .table td:nth-child(2) {\n  width: 35%;\n  min-width: 35%;\n}\n.finding .table td:nth-child(3) {\n  width: 60%;\n  min-width: 60%;\n}\n.report-wrapper td ul {\n  padding: 0;\n}\n.report-wrapper td ul li {\n  list-style: none;\n  padding: 0.35rem 0;\n}\n.finding .table thead th {\n  border: 0;\n}\n@media print {\n  .report-wrapper .table td,\n  .report-wrapper .table th {\n    background-color: transparent !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
